import { Trans, t } from "@lingui/macro"
import { Button, TextField, Typography, Box } from "@mui/material"
import { useState } from "react"

interface Props {
    setInput: React.Dispatch<React.SetStateAction<string>>
    setSwitcher: React.Dispatch<React.SetStateAction<string>>
    input: string
}

export const FormComponent = (props:Props) => {
    const [error, setError] = useState<string | null>(null);

    /* Validate email format */
    const validateEmail = (email: string): boolean => {
        if (!email.trim()) {
            setError(t`Email is required`);
            return false;
        }
        
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
            setError(t`Please enter a valid email address`);
            return false;
        }
        
        setError(null);
        return true;
    };

    /* What happens on submit */
    const handleSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (validateEmail(props.input)) {
            props.setSwitcher("captcha");
        }
    }

    return (
        <Box component={"form"} onSubmit={(event) => {handleSubmit(event)}}>
            <Box 
                sx={{
                    ".MuiTypography-h6": {
                    }
                }}>
                <Typography variant="h6"><Trans>Join our newsletter</Trans></Typography>
                <Typography sx={{margin: "1rem 0 0 0!important"}} variant="body1"><Trans>Sign up to our newsletter to stay up to date.</Trans></Typography>
            </Box>
            <Box>
                <TextField
                    sx={{
                        input: {
                            background: "unset",
                            border: "unset",
                            padding: ".5rem",
                            fontSize: "1rem"
                        },
                        overflow: "hidden",
                        margin: "1rem 0 1rem 0"
                    }}
                    placeholder={t`Enter your email`}
                    size="small"
                    type={"email"}
                    fullWidth
                    value={props.input}
                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                        props.setInput(event.target.value);
                        if (error) setError(null);
                    }}
                    error={!!error}
                    helperText={error}
                    required
                />
                <Button
                    sx={{
                        width: "fit-content",
                        height: "2.2rem"
                    }}
                    type="submit"
                    variant="contained">
                    <Trans>Sign up</Trans>
                </Button>
            </Box>
        </Box>
    )
}